import React from 'react';

export const WaveStarLandingPageBackground: React.FC<React.SVGProps<
  SVGSVGElement
>> = () => (
  <svg
    width="1280"
    height="300"
    viewBox="0 0 1280 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-22.3577 273.066C-22.3523 273.063 -22.3457 273.06 -53.8036 226.139C-85.2615 179.218 -85.2523 179.213 -85.2418 179.208L-84.888 179.031L-84.0284 178.604C-83.2959 178.241 -82.247 177.724 -80.8977 177.063C-78.1993 175.742 -74.297 173.847 -69.3184 171.472C-59.3657 166.723 -45.0855 160.041 -27.5021 152.17C7.57838 136.467 56.2241 115.847 110.143 96.3883C163.788 77.0282 224.209 58.2482 282.554 46.8661C339.192 35.817 401.948 30.06 456.108 43.519C489.789 51.889 533.389 66.9959 573.614 83.4542C609.375 98.0856 646.894 115.578 674.166 132.612C677.044 132.433 681.206 132.008 686.923 131.105C707.144 127.912 733.281 121.124 767.959 112.1L769.894 111.596C834.328 94.8264 923.206 71.6948 1008.48 74.6164C1095.63 77.6021 1191.06 104.844 1260.95 129.098C1296.71 141.504 1327.42 153.718 1349.24 162.847C1360.17 167.42 1368.92 171.241 1375.02 173.955C1378.07 175.312 1380.46 176.394 1382.13 177.156C1382.53 177.342 1382.9 177.509 1383.22 177.657C1383.55 177.811 1383.84 177.944 1384.08 178.055L1384.64 178.315L1384.82 178.395L1384.9 178.434C1384.91 178.438 1384.92 178.443 1355.06 226.137C1325.19 273.831 1325.2 273.834 1325.21 273.837L1324.89 273.689C1324.6 273.556 1324.13 273.34 1323.49 273.045C1322.2 272.456 1320.21 271.553 1317.57 270.382C1312.31 268.037 1304.49 264.62 1294.58 260.476C1274.73 252.17 1246.7 241.028 1214.21 229.753C1147.61 206.644 1068.51 185.22 1003.52 182.993C942.052 180.887 872.749 198.101 804.13 215.958C802.626 216.349 801.118 216.742 799.606 217.135C769.017 225.102 736.865 233.476 709.469 237.802C694.897 240.102 678.439 241.823 662.088 240.953C645.953 240.095 624.336 236.417 605.121 223.407C588.759 212.328 557.25 196.757 519.933 181.489C483.281 166.493 446.349 153.949 421.439 147.759C398.037 141.943 360.44 142.861 310.177 152.667C261.62 162.14 208.593 178.394 158.485 196.477C108.649 214.462 63.2363 233.695 30.1967 248.484C13.72 255.86 0.424848 262.083 -8.68293 266.429C-13.2345 268.6 -16.7337 270.3 -19.0543 271.436C-20.2144 272.004 -21.0793 272.431 -21.6333 272.705L-22.2288 273.001L-22.3577 273.066ZM669.377 132.663C669.38 132.661 669.462 132.667 669.616 132.685C669.452 132.674 669.375 132.665 669.377 132.663Z"
      fill="url(#paint0_angular_373_5578)"
    />
    <path
      d="M574.682 36.2656C574.682 36.2656 575.772 46.5953 580.019 50.9061C584.266 55.2168 594.442 56.3235 594.442 56.3235C594.442 56.3235 584.266 57.4302 580.019 61.7409C575.772 66.0517 574.682 76.3814 574.682 76.3814C574.682 76.3814 573.592 66.0517 569.345 61.7409C565.098 57.4302 554.922 56.3235 554.922 56.3235C554.922 56.3235 565.098 55.2168 569.345 50.9061C573.592 46.5953 574.682 36.2656 574.682 36.2656Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M217.065 151.633C217.065 151.633 218.155 161.962 222.402 166.273C226.649 170.584 236.825 171.691 236.825 171.691C236.825 171.691 226.649 172.797 222.402 177.108C218.155 181.419 217.065 191.749 217.065 191.749C217.065 191.749 215.975 181.419 211.728 177.108C207.481 172.797 197.305 171.691 197.305 171.691C197.305 171.691 207.481 170.584 211.728 166.273C215.975 161.962 217.065 151.633 217.065 151.633Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M559.557 259.32C559.557 259.32 560.647 269.65 564.894 273.961C569.141 278.271 579.317 279.378 579.317 279.378C579.317 279.378 569.141 280.485 564.894 284.796C560.647 289.106 559.557 299.436 559.557 299.436C559.557 299.436 558.467 289.106 554.22 284.796C549.973 280.485 539.797 279.378 539.797 279.378C539.797 279.378 549.973 278.271 554.22 273.961C558.467 269.65 559.557 259.32 559.557 259.32Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M772.237 191.633C772.237 191.633 773.327 201.962 777.574 206.273C781.821 210.584 791.997 211.691 791.997 211.691C791.997 211.691 781.821 212.797 777.574 217.108C773.327 221.419 772.237 231.749 772.237 231.749C772.237 231.749 771.147 221.419 766.9 217.108C762.653 212.797 752.477 211.691 752.477 211.691C752.477 211.691 762.653 210.584 766.9 206.273C771.147 201.962 772.237 191.633 772.237 191.633Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1185.14 179.07C1185.14 179.07 1186.23 189.4 1190.48 193.711C1194.73 198.021 1204.9 199.128 1204.9 199.128C1204.9 199.128 1194.73 200.235 1190.48 204.546C1186.23 208.856 1185.14 219.186 1185.14 219.186C1185.14 219.186 1184.05 208.856 1179.81 204.546C1175.56 200.235 1165.38 199.128 1165.38 199.128C1165.38 199.128 1175.56 198.021 1179.81 193.711C1184.05 189.4 1185.14 179.07 1185.14 179.07Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M447.581 0.648438C447.581 0.648438 448.807 12.2687 453.585 17.1181C458.362 21.9674 469.81 23.2124 469.81 23.2124C469.81 23.2124 458.362 24.4573 453.585 29.3067C448.807 34.156 447.581 45.7763 447.581 45.7763C447.581 45.7763 446.354 34.156 441.577 29.3067C436.799 24.4573 425.352 23.2124 425.352 23.2124C425.352 23.2124 436.799 21.9674 441.577 17.1181C446.354 12.2687 447.581 0.648438 447.581 0.648438Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M176.393 11.3359C176.393 11.3359 177.62 22.9562 182.397 27.8056C187.174 32.6549 198.622 33.8999 198.622 33.8999C198.622 33.8999 187.174 35.1448 182.397 39.9942C177.62 44.8435 176.393 56.4638 176.393 56.4638C176.393 56.4638 175.167 44.8435 170.389 39.9942C165.612 35.1448 154.164 33.8999 154.164 33.8999C154.164 33.8999 165.612 32.6549 170.389 27.8056C175.167 22.9562 176.393 11.3359 176.393 11.3359Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M814.854 55.0625C814.854 55.0625 816.081 66.6828 820.858 71.5321C825.635 76.3815 837.083 77.6264 837.083 77.6264C837.083 77.6264 825.635 78.8714 820.858 83.7207C816.081 88.5701 814.854 100.19 814.854 100.19C814.854 100.19 813.628 88.5701 808.85 83.7207C804.073 78.8714 792.625 77.6264 792.625 77.6264C792.625 77.6264 804.073 76.3815 808.85 71.5321C813.628 66.6828 814.854 55.0625 814.854 55.0625Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M287.51 71.9844C287.51 71.9844 288.376 80.1864 291.748 83.6092C295.12 87.0321 303.201 87.9108 303.201 87.9108C303.201 87.9108 295.12 88.7896 291.748 92.2124C288.376 95.6353 287.51 103.837 287.51 103.837C287.51 103.837 286.645 95.6353 283.273 92.2124C279.901 88.7896 271.82 87.9108 271.82 87.9108C271.82 87.9108 279.901 87.0321 283.273 83.6092C286.645 80.1864 287.51 71.9844 287.51 71.9844Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M91.2683 83.3438C91.2683 83.3438 92.134 91.5458 95.506 94.9686C98.8781 98.3915 106.958 99.2702 106.958 99.2702C106.958 99.2702 98.8781 100.149 95.506 103.572C92.134 106.995 91.2683 115.197 91.2683 115.197C91.2683 115.197 90.4026 106.995 87.0305 103.572C83.6585 100.149 75.5781 99.2702 75.5781 99.2702C75.5781 99.2702 83.6585 98.3915 87.0305 94.9686C90.4026 91.5458 91.2683 83.3438 91.2683 83.3438Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M651.034 84.2656C651.034 84.2656 651.9 92.4676 655.272 95.8905C658.644 99.3133 666.724 100.192 666.724 100.192C666.724 100.192 658.644 101.071 655.272 104.494C651.9 107.917 651.034 116.119 651.034 116.119C651.034 116.119 650.168 107.917 646.796 104.494C643.424 101.071 635.344 100.192 635.344 100.192C635.344 100.192 643.424 99.3133 646.796 95.8905C650.168 92.4676 651.034 84.2656 651.034 84.2656Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M376.104 52.8281C376.104 52.8281 376.97 61.0301 380.342 64.453C383.714 67.8758 391.794 68.7546 391.794 68.7546C391.794 68.7546 383.714 69.6333 380.342 73.0562C376.97 76.479 376.104 84.681 376.104 84.681C376.104 84.681 375.239 76.479 371.866 73.0562C368.494 69.6333 360.414 68.7546 360.414 68.7546C360.414 68.7546 368.494 67.8758 371.866 64.453C375.239 61.0301 376.104 52.8281 376.104 52.8281Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M179.862 64.1875C179.862 64.1875 180.728 72.3895 184.1 75.8124C187.472 79.2352 195.552 80.114 195.552 80.114C195.552 80.114 187.472 80.9927 184.1 84.4155C180.728 87.8384 179.862 96.0404 179.862 96.0404C179.862 96.0404 178.996 87.8384 175.624 84.4155C172.252 80.9927 164.172 80.114 164.172 80.114C164.172 80.114 172.252 79.2352 175.624 75.8124C178.996 72.3895 179.862 64.1875 179.862 64.1875Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M950.549 16.2031C950.549 16.2031 951.639 26.5327 955.886 30.8434C960.133 35.1542 970.309 36.2608 970.309 36.2608C970.309 36.2608 960.133 37.3675 955.886 41.6783C951.639 45.989 950.549 56.3186 950.549 56.3186C950.549 56.3186 949.459 45.989 945.212 41.6783C940.965 37.3675 930.789 36.2608 930.789 36.2608C930.789 36.2608 940.965 35.1542 945.212 30.8434C949.459 26.5327 950.549 16.2031 950.549 16.2031Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1132.99 22.4141C1132.99 22.4141 1134.08 32.7437 1138.32 37.0544C1142.57 41.3651 1152.75 42.4718 1152.75 42.4718C1152.75 42.4718 1142.57 43.5785 1138.32 47.8892C1134.08 52.1999 1132.99 62.5295 1132.99 62.5295C1132.99 62.5295 1131.9 52.1999 1127.65 47.8892C1123.4 43.5785 1113.23 42.4718 1113.23 42.4718C1113.23 42.4718 1123.4 41.3651 1127.65 37.0544C1131.9 32.7437 1132.99 22.4141 1132.99 22.4141Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M511.372 166.789C511.372 166.789 511.917 171.954 514.041 174.109C516.164 176.265 521.252 176.818 521.252 176.818C521.252 176.818 516.164 177.371 514.041 179.527C511.917 181.682 511.372 186.847 511.372 186.847C511.372 186.847 510.827 181.682 508.704 179.527C506.58 177.371 501.492 176.818 501.492 176.818C501.492 176.818 506.58 176.265 508.704 174.109C510.827 171.954 511.372 166.789 511.372 166.789Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M874.896 179.07C874.896 179.07 875.441 184.235 877.564 186.391C879.688 188.546 884.776 189.099 884.776 189.099C884.776 189.099 879.688 189.653 877.564 191.808C875.441 193.963 874.896 199.128 874.896 199.128C874.896 199.128 874.351 193.963 872.227 191.808C870.104 189.653 865.016 189.099 865.016 189.099C865.016 189.099 870.104 188.546 872.227 186.391C874.351 184.235 874.896 179.07 874.896 179.07Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M891.438 158.414C891.438 158.414 892.159 165.251 894.97 168.104C897.78 170.957 904.516 171.689 904.516 171.689C904.516 171.689 897.78 172.422 894.97 175.275C892.159 178.128 891.438 184.964 891.438 184.964C891.438 184.964 890.716 178.128 887.905 175.275C885.095 172.422 878.359 171.689 878.359 171.689C878.359 171.689 885.095 170.957 887.905 168.104C890.716 165.251 891.438 158.414 891.438 158.414Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M507.492 114.664C507.492 114.664 508.214 121.501 511.024 124.354C513.835 127.207 520.57 127.939 520.57 127.939C520.57 127.939 513.835 128.672 511.024 131.525C508.214 134.378 507.492 141.214 507.492 141.214C507.492 141.214 506.771 134.378 503.96 131.525C501.149 128.672 494.414 127.939 494.414 127.939C494.414 127.939 501.149 127.207 503.96 124.354C506.771 121.501 507.492 114.664 507.492 114.664Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M311.25 126.023C311.25 126.023 311.972 132.86 314.782 135.713C317.593 138.566 324.328 139.299 324.328 139.299C324.328 139.299 317.593 140.031 314.782 142.884C311.972 145.737 311.25 152.574 311.25 152.574C311.25 152.574 310.528 145.737 307.718 142.884C304.907 140.031 298.172 139.299 298.172 139.299C298.172 139.299 304.907 138.566 307.718 135.713C310.528 132.86 311.25 126.023 311.25 126.023Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M232.555 83.2188C232.555 83.2188 233.276 90.0553 236.087 92.9084C238.898 95.7614 245.633 96.4938 245.633 96.4938C245.633 96.4938 238.898 97.2263 236.087 100.079C233.276 102.932 232.555 109.769 232.555 109.769C232.555 109.769 231.833 102.932 229.022 100.079C226.212 97.2263 219.477 96.4938 219.477 96.4938C219.477 96.4938 226.212 95.7614 229.022 92.9084C231.833 90.0553 232.555 83.2188 232.555 83.2188Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M36.3125 94.5781C36.3125 94.5781 37.0341 101.415 39.8448 104.268C42.6555 107.121 49.3906 107.853 49.3906 107.853C49.3906 107.853 42.6555 108.586 39.8448 111.439C37.0341 114.292 36.3125 121.128 36.3125 121.128C36.3125 121.128 35.5909 114.292 32.7802 111.439C29.9695 108.586 23.2344 107.853 23.2344 107.853C23.2344 107.853 29.9695 107.121 32.7802 104.268C35.5909 101.415 36.3125 94.5781 36.3125 94.5781Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M871.016 126.945C871.016 126.945 871.737 133.782 874.548 136.635C877.359 139.488 884.094 140.22 884.094 140.22C884.094 140.22 877.359 140.953 874.548 143.806C871.737 146.659 871.016 153.495 871.016 153.495C871.016 153.495 870.294 146.659 867.483 143.806C864.673 140.953 857.938 140.22 857.938 140.22C857.938 140.22 864.673 139.488 867.483 136.635C870.294 133.782 871.016 126.945 871.016 126.945Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1103.88 202.273C1103.88 202.273 1104.6 209.11 1107.41 211.963C1110.22 214.816 1116.95 215.549 1116.95 215.549C1116.95 215.549 1110.22 216.281 1107.41 219.134C1104.6 221.987 1103.88 228.824 1103.88 228.824C1103.88 228.824 1103.15 221.987 1100.34 219.134C1097.53 216.281 1090.8 215.549 1090.8 215.549C1090.8 215.549 1097.53 214.816 1100.34 211.963C1103.15 209.11 1103.88 202.273 1103.88 202.273Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M491.164 145.141C491.164 145.141 491.886 151.977 494.696 154.83C497.507 157.683 504.242 158.416 504.242 158.416C504.242 158.416 497.507 159.148 494.696 162.001C491.886 164.854 491.164 171.691 491.164 171.691C491.164 171.691 490.442 164.854 487.632 162.001C484.821 159.148 478.086 158.416 478.086 158.416C478.086 158.416 484.821 157.683 487.632 154.83C490.442 151.977 491.164 145.141 491.164 145.141Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M854.688 157.422C854.688 157.422 855.409 164.258 858.22 167.111C861.03 169.965 867.766 170.697 867.766 170.697C867.766 170.697 861.03 171.429 858.22 174.282C855.409 177.135 854.688 183.972 854.688 183.972C854.688 183.972 853.966 177.135 851.155 174.282C848.345 171.429 841.609 170.697 841.609 170.697C841.609 170.697 848.345 169.965 851.155 167.111C853.966 164.258 854.688 157.422 854.688 157.422Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1050.58 100.375C1050.58 100.375 1051.3 107.212 1054.11 110.065C1056.92 112.918 1063.66 113.65 1063.66 113.65C1063.66 113.65 1056.92 114.383 1054.11 117.236C1051.3 120.089 1050.58 126.925 1050.58 126.925C1050.58 126.925 1049.86 120.089 1047.05 117.236C1044.24 114.383 1037.5 113.65 1037.5 113.65C1037.5 113.65 1044.24 112.918 1047.05 110.065C1049.86 107.212 1050.58 100.375 1050.58 100.375Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1233.02 106.586C1233.02 106.586 1233.74 113.423 1236.55 116.276C1239.36 119.129 1246.09 119.861 1246.09 119.861C1246.09 119.861 1239.36 120.593 1236.55 123.447C1233.74 126.3 1233.02 133.136 1233.02 133.136C1233.02 133.136 1232.29 126.3 1229.48 123.447C1226.67 120.593 1219.94 119.861 1219.94 119.861C1219.94 119.861 1226.67 119.129 1229.48 116.276C1232.29 113.423 1233.02 106.586 1233.02 106.586Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1246.09 192.82C1246.09 192.82 1246.82 199.657 1249.63 202.51C1252.44 205.363 1259.17 206.095 1259.17 206.095C1259.17 206.095 1252.44 206.828 1249.63 209.681C1246.82 212.534 1246.09 219.37 1246.09 219.37C1246.09 219.37 1245.37 212.534 1242.56 209.681C1239.75 206.828 1233.02 206.095 1233.02 206.095C1233.02 206.095 1239.75 205.363 1242.56 202.51C1245.37 199.657 1246.09 192.82 1246.09 192.82Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1071.04 32.6641C1071.04 32.6641 1071.76 39.5007 1074.57 42.3537C1077.38 45.2067 1084.12 45.9392 1084.12 45.9392C1084.12 45.9392 1077.38 46.6716 1074.57 49.5246C1071.76 52.3777 1071.04 59.2142 1071.04 59.2142C1071.04 59.2142 1070.32 52.3777 1067.51 49.5246C1064.7 46.6716 1057.96 45.9392 1057.96 45.9392C1057.96 45.9392 1064.7 45.2067 1067.51 42.3537C1070.32 39.5007 1071.04 32.6641 1071.04 32.6641Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1253.48 38.875C1253.48 38.875 1254.2 45.7116 1257.01 48.5646C1259.82 51.4176 1266.55 52.1501 1266.55 52.1501C1266.55 52.1501 1259.82 52.8826 1257.01 55.7356C1254.2 58.5886 1253.48 65.4252 1253.48 65.4252C1253.48 65.4252 1252.75 58.5886 1249.94 55.7356C1247.13 52.8826 1240.4 52.1501 1240.4 52.1501C1240.4 52.1501 1247.13 51.4176 1249.94 48.5646C1252.75 45.7116 1253.48 38.875 1253.48 38.875Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M605.531 101.172C605.531 101.172 606.253 108.008 609.064 110.861C611.874 113.715 618.609 114.447 618.609 114.447C618.609 114.447 611.874 115.179 609.064 118.032C606.253 120.885 605.531 127.722 605.531 127.722C605.531 127.722 604.81 120.885 601.999 118.032C599.188 115.179 592.453 114.447 592.453 114.447C592.453 114.447 599.188 113.715 601.999 110.861C604.81 108.008 605.531 101.172 605.531 101.172Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M969.055 113.461C969.055 113.461 969.776 120.298 972.587 123.151C975.398 126.004 982.133 126.736 982.133 126.736C982.133 126.736 975.398 127.468 972.587 130.322C969.776 133.175 969.055 140.011 969.055 140.011C969.055 140.011 968.333 133.175 965.522 130.322C962.712 127.468 955.977 126.736 955.977 126.736C955.977 126.736 962.712 126.004 965.522 123.151C968.333 120.298 969.055 113.461 969.055 113.461Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1151.49 119.672C1151.49 119.672 1152.21 126.508 1155.02 129.361C1157.84 132.215 1164.57 132.947 1164.57 132.947C1164.57 132.947 1157.84 133.679 1155.02 136.532C1152.21 139.385 1151.49 146.222 1151.49 146.222C1151.49 146.222 1150.77 139.385 1147.96 136.532C1145.15 133.679 1138.41 132.947 1138.41 132.947C1138.41 132.947 1145.15 132.215 1147.96 129.361C1150.77 126.508 1151.49 119.672 1151.49 119.672Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M622.086 202.086C622.086 202.086 622.808 208.923 625.618 211.776C628.429 214.629 635.164 215.361 635.164 215.361C635.164 215.361 628.429 216.093 625.618 218.947C622.808 221.8 622.086 228.636 622.086 228.636C622.086 228.636 621.364 221.8 618.554 218.947C615.743 216.093 609.008 215.361 609.008 215.361C609.008 215.361 615.743 214.629 618.554 211.776C621.364 208.923 622.086 202.086 622.086 202.086Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M362.008 118.484C362.008 118.484 362.729 125.321 365.54 128.174C368.351 131.027 375.086 131.759 375.086 131.759C375.086 131.759 368.351 132.492 365.54 135.345C362.729 138.198 362.008 145.035 362.008 145.035C362.008 145.035 361.286 138.198 358.476 135.345C355.665 132.492 348.93 131.759 348.93 131.759C348.93 131.759 355.665 131.027 358.476 128.174C361.286 125.321 362.008 118.484 362.008 118.484Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M165.766 129.844C165.766 129.844 166.487 136.68 169.298 139.533C172.109 142.386 178.844 143.119 178.844 143.119C178.844 143.119 172.109 143.851 169.298 146.704C166.487 149.557 165.766 156.394 165.766 156.394C165.766 156.394 165.044 149.557 162.233 146.704C159.423 143.851 152.688 143.119 152.688 143.119C152.688 143.119 159.423 142.386 162.233 139.533C165.044 136.68 165.766 129.844 165.766 129.844Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M725.531 130.773C725.531 130.773 726.253 137.61 729.064 140.463C731.874 143.316 738.609 144.049 738.609 144.049C738.609 144.049 731.874 144.781 729.064 147.634C726.253 150.487 725.531 157.324 725.531 157.324C725.531 157.324 724.81 150.487 721.999 147.634C719.188 144.781 712.453 144.049 712.453 144.049C712.453 144.049 719.188 143.316 721.999 140.463C724.81 137.61 725.531 130.773 725.531 130.773Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M450.594 99.3281C450.594 99.3281 451.315 106.165 454.126 109.018C456.937 111.871 463.672 112.603 463.672 112.603C463.672 112.603 456.937 113.336 454.126 116.189C451.315 119.042 450.594 125.878 450.594 125.878C450.594 125.878 449.872 119.042 447.061 116.189C444.251 113.336 437.516 112.603 437.516 112.603C437.516 112.603 444.251 111.871 447.061 109.018C449.872 106.165 450.594 99.3281 450.594 99.3281Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M254.352 110.688C254.352 110.688 255.073 117.524 257.884 120.377C260.695 123.23 267.43 123.963 267.43 123.963C267.43 123.963 260.695 124.695 257.884 127.548C255.073 130.401 254.352 137.238 254.352 137.238C254.352 137.238 253.63 130.401 250.819 127.548C248.009 124.695 241.273 123.963 241.273 123.963C241.273 123.963 248.009 123.23 250.819 120.377C253.63 117.524 254.352 110.688 254.352 110.688Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M418.247 142.352C418.247 142.352 418.878 148.325 421.334 150.818C423.79 153.311 429.674 153.951 429.674 153.951C429.674 153.951 423.79 154.591 421.334 157.084C418.878 159.576 418.247 165.55 418.247 165.55C418.247 165.55 417.617 159.576 415.161 157.084C412.705 154.591 406.82 153.951 406.82 153.951C406.82 153.951 412.705 153.311 415.161 150.818C417.617 148.325 418.247 142.352 418.247 142.352Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M998.177 175.523C998.177 175.523 998.808 181.497 1001.26 183.99C1003.72 186.483 1009.6 187.123 1009.6 187.123C1009.6 187.123 1003.72 187.763 1001.26 190.255C998.808 192.748 998.177 198.722 998.177 198.722C998.177 198.722 997.547 192.748 995.091 190.255C992.635 187.763 986.75 187.123 986.75 187.123C986.75 187.123 992.635 186.483 995.091 183.99C997.547 181.497 998.177 175.523 998.177 175.523Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M695.279 76.375C695.279 76.375 695.909 82.3485 698.365 84.8413C700.821 87.3342 706.706 87.9741 706.706 87.9741C706.706 87.9741 700.821 88.6141 698.365 91.107C695.909 93.5998 695.279 99.5733 695.279 99.5733C695.279 99.5733 694.648 93.5998 692.192 91.107C689.736 88.6141 683.852 87.9741 683.852 87.9741C683.852 87.9741 689.736 87.3342 692.192 84.8413C694.648 82.3485 695.279 76.375 695.279 76.375Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1148.35 81.4375C1148.35 81.4375 1148.98 87.411 1151.44 89.9038C1153.89 92.3967 1159.78 93.0366 1159.78 93.0366C1159.78 93.0366 1153.89 93.6766 1151.44 96.1695C1148.98 98.6623 1148.35 104.636 1148.35 104.636C1148.35 104.636 1147.72 98.6623 1145.26 96.1695C1142.81 93.6766 1136.92 93.0366 1136.92 93.0366C1136.92 93.0366 1142.81 92.3967 1145.26 89.9038C1147.72 87.411 1148.35 81.4375 1148.35 81.4375Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1136.08 142.281C1136.08 142.281 1136.71 148.255 1139.17 150.748C1141.63 153.24 1147.51 153.88 1147.51 153.88C1147.51 153.88 1141.63 154.52 1139.17 157.013C1136.71 159.506 1136.08 165.48 1136.08 165.48C1136.08 165.48 1135.45 159.506 1133 157.013C1130.54 154.52 1124.66 153.88 1124.66 153.88C1124.66 153.88 1130.54 153.24 1133 150.748C1135.45 148.255 1136.08 142.281 1136.08 142.281Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M594.107 137.648C594.107 137.648 594.737 143.622 597.193 146.115C599.649 148.608 605.534 149.248 605.534 149.248C605.534 149.248 599.649 149.888 597.193 152.38C594.737 154.873 594.107 160.847 594.107 160.847C594.107 160.847 593.476 154.873 591.02 152.38C588.565 149.888 582.68 149.248 582.68 149.248C582.68 149.248 588.565 148.608 591.02 146.115C593.476 143.622 594.107 137.648 594.107 137.648Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M319.161 106.203C319.161 106.203 319.792 112.177 322.248 114.669C324.704 117.162 330.588 117.802 330.588 117.802C330.588 117.802 324.704 118.442 322.248 120.935C319.792 123.428 319.161 129.401 319.161 129.401C319.161 129.401 318.531 123.428 316.075 120.935C313.619 118.442 307.734 117.802 307.734 117.802C307.734 117.802 313.619 117.162 316.075 114.669C318.531 112.177 319.161 106.203 319.161 106.203Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M247.138 226.281C247.138 226.281 247.768 232.255 250.224 234.748C252.68 237.24 258.565 237.88 258.565 237.88C258.565 237.88 252.68 238.52 250.224 241.013C247.768 243.506 247.138 249.48 247.138 249.48C247.138 249.48 246.507 243.506 244.052 241.013C241.596 238.52 235.711 237.88 235.711 237.88C235.711 237.88 241.596 237.24 244.052 234.748C246.507 232.255 247.138 226.281 247.138 226.281Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M610.661 238.555C610.661 238.555 611.292 244.528 613.748 247.021C616.204 249.514 622.088 250.154 622.088 250.154C622.088 250.154 616.204 250.794 613.748 253.287C611.292 255.779 610.661 261.753 610.661 261.753C610.661 261.753 610.031 255.779 607.575 253.287C605.119 250.794 599.234 250.154 599.234 250.154C599.234 250.154 605.119 249.514 607.575 247.021C610.031 244.528 610.661 238.555 610.661 238.555Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M335.724 207.117C335.724 207.117 336.354 213.091 338.81 215.584C341.266 218.076 347.151 218.716 347.151 218.716C347.151 218.716 341.266 219.356 338.81 221.849C336.354 224.342 335.724 230.315 335.724 230.315C335.724 230.315 335.093 224.342 332.638 221.849C330.182 219.356 324.297 218.716 324.297 218.716C324.297 218.716 330.182 218.076 332.638 215.584C335.093 213.091 335.724 207.117 335.724 207.117Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M883.38 104.742C883.38 104.742 884.011 110.716 886.467 113.209C888.922 115.701 894.807 116.341 894.807 116.341C894.807 116.341 888.922 116.981 886.467 119.474C884.011 121.967 883.38 127.94 883.38 127.94C883.38 127.94 882.75 121.967 880.294 119.474C877.838 116.981 871.953 116.341 871.953 116.341C871.953 116.341 877.838 115.701 880.294 113.209C882.75 110.716 883.38 104.742 883.38 104.742Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M720.513 87.9141C720.513 87.9141 721.143 93.8875 723.599 96.3804C726.055 98.8732 731.94 99.5132 731.94 99.5132C731.94 99.5132 726.055 100.153 723.599 102.646C721.143 105.139 720.513 111.112 720.513 111.112C720.513 111.112 719.882 105.139 717.427 102.646C714.971 100.153 709.086 99.5132 709.086 99.5132C709.086 99.5132 714.971 98.8732 717.427 96.3804C719.882 93.8875 720.513 87.9141 720.513 87.9141Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M441.825 14.3281C441.825 14.3281 442.456 20.3016 444.912 22.7944C447.368 25.2873 453.253 25.9273 453.253 25.9273C453.253 25.9273 447.368 26.5673 444.912 29.0601C442.456 31.5529 441.825 37.5264 441.825 37.5264C441.825 37.5264 441.195 31.5529 438.739 29.0601C436.283 26.5673 430.398 25.9273 430.398 25.9273C430.398 25.9273 436.283 25.2873 438.739 22.7944C441.195 20.3016 441.825 14.3281 441.825 14.3281Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M245.583 25.6875C245.583 25.6875 246.214 31.661 248.67 34.1538C251.125 36.6467 257.01 37.2866 257.01 37.2866C257.01 37.2866 251.125 37.9266 248.67 40.4195C246.214 42.9123 245.583 48.8858 245.583 48.8858C245.583 48.8858 244.953 42.9123 242.497 40.4195C240.041 37.9266 234.156 37.2866 234.156 37.2866C234.156 37.2866 240.041 36.6467 242.497 34.1538C244.953 31.661 245.583 25.6875 245.583 25.6875Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M1084.04 100.195C1084.04 100.195 1084.67 106.169 1087.12 108.662C1089.58 111.154 1095.46 111.794 1095.46 111.794C1095.46 111.794 1089.58 112.434 1087.12 114.927C1084.67 117.42 1084.04 123.394 1084.04 123.394C1084.04 123.394 1083.41 117.42 1080.95 114.927C1078.49 112.434 1072.61 111.794 1072.61 111.794C1072.61 111.794 1078.49 111.154 1080.95 108.662C1083.41 106.169 1084.04 100.195 1084.04 100.195Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M373.544 176.531C373.544 176.531 374.175 182.505 376.631 184.998C379.086 187.49 384.971 188.13 384.971 188.13C384.971 188.13 379.086 188.77 376.631 191.263C374.175 193.756 373.544 199.73 373.544 199.73C373.544 199.73 372.914 193.756 370.458 191.263C368.002 188.77 362.117 188.13 362.117 188.13C362.117 188.13 368.002 187.49 370.458 184.998C372.914 182.505 373.544 176.531 373.544 176.531Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M736.958 259.469C736.958 259.469 737.589 265.442 740.045 267.935C742.5 270.428 748.385 271.068 748.385 271.068C748.385 271.068 742.5 271.708 740.045 274.201C737.589 276.694 736.958 282.667 736.958 282.667C736.958 282.667 736.328 276.694 733.872 274.201C731.416 271.708 725.531 271.068 725.531 271.068C725.531 271.068 731.416 270.428 733.872 267.935C736.328 265.442 736.958 259.469 736.958 259.469Z"
      fill="white"
      fillOpacity="0.3"
    />
    <path
      d="M462.13 157.375C462.13 157.375 462.761 163.348 465.217 165.841C467.672 168.334 473.557 168.974 473.557 168.974C473.557 168.974 467.672 169.614 465.217 172.107C462.761 174.6 462.13 180.573 462.13 180.573C462.13 180.573 461.5 174.6 459.044 172.107C456.588 169.614 450.703 168.974 450.703 168.974C450.703 168.974 456.588 168.334 459.044 165.841C461.5 163.348 462.13 157.375 462.13 157.375Z"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="795.854"
      cy="141.317"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="1159.39"
      cy="153.598"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.5"
    />
    <ellipse
      cx="574.221"
      cy="210.848"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="299.284"
      cy="179.403"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="937.737"
      cy="223.129"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="447.565"
      cy="116.34"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="251.323"
      cy="127.7"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="833.377"
      cy="107.621"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="643.768"
      cy="131.762"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="368.83"
      cy="100.317"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="172.588"
      cy="111.676"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="437.463"
      cy="172.606"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="539.791"
      cy="127.942"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="264.862"
      cy="96.4965"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="903.323"
      cy="140.223"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="1136.18"
      cy="215.551"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="417.643"
      cy="76.5902"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="268.057"
      cy="243.223"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.5"
    />
    <ellipse
      cx="631.58"
      cy="255.504"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="356.651"
      cy="224.059"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="761.823"
      cy="255.395"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="1157.35"
      cy="181.786"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="970.323"
      cy="141.465"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="1034.99"
      cy="114.848"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.5"
    />
    <ellipse
      cx="1036.66"
      cy="196.411"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="1101.02"
      cy="243.223"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="1060.28"
      cy="167.871"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="663.635"
      cy="122.489"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.5"
    />
    <ellipse
      cx="388.698"
      cy="91.0433"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="937.932"
      cy="51.4027"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <ellipse
      cx="1120.37"
      cy="57.6137"
      rx="3.76015"
      ry="3.81678"
      fill="white"
      fillOpacity="0.3"
    />
    <defs>
      <radialGradient
        id="paint0_angular_373_5578"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(692.601 190.45) rotate(-71.1793) scale(155.701 675.393)"
      >
        <stop offset="0.0677083" stopColor="white" stopOpacity="0.19" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export default WaveStarLandingPageBackground;
